<template>
  <v-main
    class="grey lighten-3"
    :style="isMobile ? 'padding-bottom: 60px' : ''"
  >
    <v-container
      fluid
      class="pt-0"
      :class="isDesktop ? 'd-flex pa-0' : ''"
    >
      <LoginBanner v-if="isDesktop" />
      <div
        :class="[
          isDesktop ? 'login-direita pt-10' : '',
          isDesktopLarge ? 'login-direita-lg pt-lg-12' : '',
        ]"
      >
        <slot />
      </div>
    </v-container>
  </v-main>
</template>

<script>
import LoginBanner from '@/components/Login/LoginBanner.vue';

export default {
  name: 'LoginBase',

  components: {
    LoginBanner,
  },

  computed: {
    isDesktop() {
      return this.$vuetify.breakpoint.mdAndUp;
    },

    isDesktopLarge() {
      return this.$vuetify.breakpoint.lgAndUp;
    },

    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
};
</script>

<style lang="scss" scoped>
.login-direita {
  width: 59vw;
  padding-left: 5vw;
  padding-right: 16px;
}
.login-direita-lg {
  padding-left: 107px;
}
</style>
